<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="seatmap-select-child-seat-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1
        id="seatmap-paid-seat-detail-confirmation-title"
        class="p-modal-head01__title"
        innerHTML="{{ seatInformationMap?.get(seatNumber!)?.isCouchSeat ? couchSeatNumber : seatNumber }}"
      ></h1>
      <button
        id="seatmap-paid-seat-detail-confirmation-close"
        class="p-modal-head01__close js-modal-close"
        aswThrottleClick
        (throttleClick$)="close()"
      >
        <span class="u-visually-hidden" innerHTML="{{ 'alt.closeModal' | staticMsg }}"> </span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="l-core-contents__inner">
      <div
        *ngIf="
          seatInformationMap?.get(seatNumber!)?.isChargeableAsrSeat === undefined
            ? false
            : seatInformationMap?.get(seatNumber!)?.isChargeableAsrSeat
        "
      >
        <div>
          <label for="checkbox1_1" class="c-form-element-checkbox-button01__label">
            <span class="c-form-element-checkbox-button01__text c-form-element-checkbox-button01__text--has-status">
              <span class="c-form-element-checkbox-button01__text-label c-text-m c-text-m--bold">
                <!-- 凡例のためalt文言は不要 -->
                <img src="assets/images/seat_paid_seat_24.svg" alt="" width="25" height="25" aria-hidden="true" />
                <span [innerHTML]="'m_static_message-label.paidSeat' | staticMsg"></span>
                <asw-tooltip
                  iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
                    'alt.helpIcon2' | staticMsg
                  }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
                  tooltipContent="{{ 'tooltip.chargeableSeat' | staticMsg }}"
                  [tooltipTop]="-50"
                >
                </asw-tooltip>
              </span>
              <span class="c-form-element-checkbox-button01__text-status" style="text-align: right">
                <div class="c-text-m c-text-m--bold" *ngIf="!hasFreePermission()">
                  {{ (getSeatPrice() | amountFormat) || 0 }}
                </div>
                <div class="c-text-xs c-text-xs--gray" *ngIf="hasFreePermission()">
                  {{ 'm_static_message-label.exemption' | staticMsg }}
                </div>
              </span>
            </span>
          </label>
        </div>
        <div class="p-modal-seatmap-seat-info__item">
          <!--　請求案内  -->
          <div *ngIf="chargableDescription" class="p-modal-seatmap-seat-info__row">
            <p
              class="p-modal-seatmap-seat-info__text p-modal-seatmap-seat-info__text--fs16"
              [innerHTML]="chargableDescription"
            ></p>
          </div>
          <!--　注意案内  -->
          <div class="p-modal-seatmap-seat-info__row">
            <ul class="c-information-list01">
              <li class="c-information-list01__item">
                {{ 'label.cautionGuide' | staticMsg }}
              </li>
            </ul>
          </div>
          <!--　適用条件  -->
          <div *ngIf="chargableAttention" class="p-modal-seatmap-seat-info__row" [innerHTML]="chargableAttention"></div>
        </div>
        <!-- chargeASRSeatImageが未設定だった時はalt文言が取得できないため<img>ごと表示しない（カウチ席の場合は未設定があり得ないため考慮不要） -->
        <div *ngIf="chargeASRSeatImage" class="p-modal-seatmap-seat-info__item">
          <!-- 座席イメージ -->
          <img
            class="p-modal-seatmap-seat-info__img"
            src="{{ chargeASRSeatImage }}"
            width="100%"
            height="100%"
            aria-hidden="true"
            alt="{{ chargeASRSeatImgAltStaticMsgKey | staticMsg }}"
          />
        </div>
      </div>
      <div *ngIf="seatInformationMap?.get(seatNumber!)?.isCouchSeat">
        <div>
          <label for="checkbox1_1" class="c-form-element-checkbox-button01__label">
            <span class="c-form-element-checkbox-button01__text c-form-element-checkbox-button01__text--has-status">
              <span class="c-form-element-checkbox-button01__text-label c-text-m c-text-m--bold">
                <!-- 凡例のためalt文言は不要 -->
                <img src="assets/images/seat_anacouchii_24.svg" alt="" width="25" height="25" aria-hidden="true" />
                <span [innerHTML]="'m_static_message-label.couchii' | staticMsg"></span>
                <span class="u-visually-hidden" [innerHTML]="'reader.seatmap.anaCouchii' | staticMsg"> </span>
                <asw-tooltip
                  iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
                    'alt.helpIcon2' | staticMsg
                  }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
                  tooltipContent="{{ 'tooltip.couchSeat' | staticMsg }}"
                  [tooltipTop]="-50"
                >
                </asw-tooltip>
              </span>
              <span class="c-form-element-checkbox-button01__text-status" *ngIf="!isInformative">
                <span class="c-text-m c-text-m--bold">{{
                  getCouchSeatLowestPrice() | amountFormat : 'default_from'
                }}</span>
              </span>
            </span>
          </label>
        </div>
        <div class="p-modal-seatmap-seat-info__item">
          <!--　請求案内  -->
          <div *ngIf="chargableDescription" class="p-modal-seatmap-seat-info__row">
            <p
              class="p-modal-seatmap-seat-info__text p-modal-seatmap-seat-info__text--fs16"
              [innerHTML]="chargableDescription"
            ></p>
          </div>
          <!--　注意案内  -->
          <div class="p-modal-seatmap-seat-info__row">
            <ul class="c-information-list01">
              <li class="c-information-list01__item">
                {{ 'label.cautionGuide' | staticMsg }}
              </li>
            </ul>
          </div>
          <!--　適用条件  -->
          <div *ngIf="chargableAttention" class="p-modal-seatmap-seat-info__row" [innerHTML]="chargableAttention"></div>
        </div>
        <div class="p-modal-seatmap-seat-info__item">
          <img
            class="p-modal-seatmap-seat-info__img"
            src="{{ couchSeatImage }}"
            width="100%"
            height="100%"
            aria-hidden="true"
            alt="{{ 'alt.paidSeatsDetailModal.couchSeat' | staticMsg }}"
          />
        </div>
        <!--　搭乗者リスト  -->
        <div class="p-modal-seatmap-seat-info__item p-modal-seatmap-seat-info__item--list">
          <fieldset class="p-modal-seatmap-seat-info__fieldset" aria-invalid="false">
            <legend class="p-modal-seatmap-seat-info__fieldset-legend">Strings</legend>
            <div class="p-modal-seatmap-seat-info__fieldset-wrap">
              <ul class="p-modal-seatmap-seat-info__list">
                <ng-container *ngFor="let passengerId of passengerIdList; index as i">
                  <li
                    class="p-modal-seatmap-seat-info__list-item"
                    [class.is-selected]="isSelected(passengerId)"
                    [class.is-unchangeable]="isChangeRestrictedAllSeat || isUnchangeable(passengerId)"
                  >
                    <div
                      class="p-modal-seatmap-seat-info__list-item-wrap"
                      aswThrottleClick
                      (throttleClick$)="onClickPassenger(passengerId)"
                    >
                      <div class="p-modal-seatmap-seat-info__btn">
                        <div class="p-modal-seatmap-seat-info__btn-wrap">
                          <input
                            type="checkbox"
                            name="checkbox1_{{ i }}"
                            id="checkbox1_{{ i }}"
                            class="p-modal-seatmap-seat-info__btn-input"
                            aria-invalid="false"
                          />
                          <label for="checkbox1_{{ i }}" class="p-modal-seatmap-seat-info__btn-label">
                            <span class="p-modal-seatmap-seat-info__btn-title">
                              <span
                                class="p-modal-seatmap-seat-info__btn-title-num"
                                [attr.aria-label]="
                                  getButtonReaderStaticMsgKey(passengerId) | staticMsg : { '0': i + 1 }
                                "
                                >{{ travelersMap?.get(passengerId)?.sequence }}</span
                              >
                              <span class="p-modal-seatmap-seat-info__btn-title-label">
                                <span class="p-modal-seatmap-seat-info__btn-title-label-member">{{
                                  travelersMap?.get(passengerId)?.name
                                }}</span>
                                <span
                                  class="p-modal-seatmap-seat-info__btn-title-label-sub"
                                  *ngIf="getInfantName(passengerId)"
                                  [innerHTML]="getInfantName(passengerId)"
                                ></span>
                              </span>
                            </span>
                            <span
                              class="p-modal-seatmap-seat-info__btn-status"
                              innerHTML="{{
                                isSelected(passengerId)
                                  ? couchSeatNumber
                                  : getSeatNumber(passengerId)
                                  ? getSeatNumber(passengerId)
                                  : ('m_static_message-label.hyphen3' | staticMsg)
                              }}"
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass" *ngIf="!isInformative">
    <div class="p-modal-foot02" *ngIf="seatInformationMap?.get(seatNumber!)?.isCouchSeat; else dialogbutton">
      <div class="p-modal-foot02__content">
        <div
          class="p-modal-foot02__content-price p-modal-foot02__content-price--em p-modal-foot02__content-price--blue"
        >
          <span class="c-amount">
            <span class="c-amount__num c-amount__num--fs24"
              >{{
                reservedCouchSeatTotalAmount === 0 || reservedCouchSeatTotalAmount
                  ? (reservedCouchSeatTotalAmount | amountFormat)
                  : ('m_static_message-label.hyphen3' | staticMsg)
              }}
            </span>
          </span>
        </div>
        <div class="p-modal-foot02__content-supp">
          {{ 'label.numberOfTravelerSelectCouchSeat' | staticMsg : { '0': couchSeatReservedPassengerCount } }}
        </div>
      </div>
      <div class="p-modal-foot02__content">
        <asw-button
          id="select-child-seat-apply"
          type="primary"
          size="s"
          [disabled]="isChangeRestrictedAllSeat"
          throttleClick
          (click$)="onSelectClick()"
        >
          <span innerHTML="{{ 'm_static_message-label.select' | staticMsg }}"> </span>
        </asw-button>
      </div>
    </div>
    <ng-template #dialogbutton>
      <div class="p-modal-foot01">
        <asw-button
          id="select-child-seat-apply"
          type="primary"
          size="s"
          [disabled]="isChangeRestrictedAllSeat"
          throttleClick
          (click$)="onSelectClick()"
        >
          <span innerHTML="{{ 'm_static_message-label.select' | staticMsg }}"> </span>
        </asw-button>
      </div>
    </ng-template>
  </div>
</div>
